import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1673231673041'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='6700'
    >
        <path
            d='M63.10934 421.364747l894.369617 0 0 178.878017-894.369617 0L63.10934 421.364747z'
            fill='currentColor'
            p-id='6701'
        ></path>
        <path
            d='M420.857187 63.620993l178.873923 0 0 894.369617-178.873923 0L420.857187 63.620993z'
            fill='currentColor'
            p-id='6702'
        ></path>
    </svg>
)

export const FolderAddOutlinedIcon = props => <Icon component={SVG} {...props} />
